import { SpacedGroup } from 'UI/Components/index'

import { TrackLinkHeader } from './TrackLinkHeader'
import { TrackLinkBody } from './TrackLinkBody'

import { PlaybookType } from 'app/types'

type Props = {
    playbook: PlaybookType
}

export const TrackLinkContent = ({ playbook }: Props) => {
    return (
        <SpacedGroup flexDirection="column" spacing={2.5}>
            <TrackLinkHeader playbook={playbook} />
            <TrackLinkBody playbook={playbook} />
        </SpacedGroup>
    )
}
